var React = require('react');

function Plant (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M15.011,6.35c0,3.083-3.006,5.583-3.006,5.583S9,9.433,9,6.35,12.005.766,12.005.766,15.011,3.266,15.011,6.35Z","key":1}),React.createElement("path",{"className":"a","d":"M20.187,20.2C17.079,23.313,12,23.266,12,23.266s-.047-5.084,3.061-8.192,8.192-3.06,8.192-3.06S23.294,17.1,20.187,20.2Z","key":2}),React.createElement("path",{"className":"a","d":"M3.808,20.2C6.916,23.313,12,23.266,12,23.266s.047-5.084-3.061-8.192S.748,12.014.748,12.014.7,17.1,3.808,20.2Z","key":3}),React.createElement("line",{"className":"a","x1":"12.005","y1":"11.933","x2":"12.005","y2":"23.266","key":4})]);
}

Plant.defaultProps = {"id":"Regular","viewBox":"0 0 24 24"};

module.exports = Plant;

Plant.default = Plant;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/plant.svg
// module id = 1079
// module chunks = 0